<h5>Selected Stands: </h5>
<div style=" height: 370px;background: white;overflow: auto;padding: 30px; " class=" mat-elevation-z8">


  <div *ngFor="let stand of stands" style="text-align: center;">
    <div style="border: solid darkblue;padding: 2px;font-size: 10px;"
      [ngStyle]="{'width.px': stand.width*10,'height.px': stand.height*10 }">{{stand.height}}x{{stand.width}}</div>
    <span style="color: #a94442;font-weight: bolder;">{{stand.num}} </span>{{stand.standType}}
     <span style="color: #704300;">{{stand.superficie}}m²</span>
   
     <button   (click)="remove(stand)">
         <mat-icon    >remove</mat-icon>
     </button> 


  </div>
</div>